import React, { createContext, useContext, ReactNode } from 'react';
import { WebSocketClient } from '../../../apis';

interface WebsocketContextProps {
    websocket: WebSocketClient;
}

const WebsocketContext = createContext<WebsocketContextProps | undefined>(undefined);

export const WebsocketProvider: React.FC<{ websocket: WebSocketClient; children: ReactNode }> = ({ websocket, children }) => {
    return (
        <WebsocketContext.Provider value={{ websocket }}>
            {children}
        </WebsocketContext.Provider>
    );
};

export const useWebsocketContext = (): WebsocketContextProps => {
    const context = useContext(WebsocketContext);
    if (!context) {
        throw new Error('useWebsocketContext must be used within a WebsocketProvider');
    }
    return context;
};
